<div class="context-menu">
  <button mat-menu-item (click)="onEditClicked()">
    <mat-icon>edit</mat-icon>
    <span>Edit Content</span>
  </button>
  <button mat-menu-item (click)="onCancelClicked()">
    <mat-icon>close</mat-icon>
    <span>Cancel</span>
  </button>
</div>
